import type { HighlightTag, HighlightTagColor } from "./ProductHighlightTag";

/**
 * Structural shape of one `product_tags` row. Declared here rather than
 * imported from the catalog domain: this composite is client-side and must
 * stay free of server-only domain code, and a structural type keeps
 * `CatalogProductTag[]` assignable without the coupling.
 */
export interface HighlightTagSource {
	kind: string;
	title: string;
	color?: string;
	icon?: string;
	startDate?: string;
	endDate?: string;
}

const HIGHLIGHT_KIND = "highlight";

const COLORS: readonly HighlightTagColor[] = [
	"default",
	"info",
	"success",
	"warning",
	"alert"
];

/**
 * Promotional badges a surface should show right now. The projection passes a
 * tag's date window through unevaluated — nothing re-projects a product when a
 * window opens or closes — so the window is resolved at render time.
 */
export function selectHighlightTags(
	productTags: HighlightTagSource[] | undefined,
	now: number = Date.now()
): HighlightTag[] {
	return (productTags ?? [])
		.filter(
			(tag) => tag.kind === HIGHLIGHT_KIND && isWithinWindow(tag, now)
		)
		.map((tag) => ({
			title: tag.title,
			color: COLORS.find((c) => c === tag.color),
			icon: tag.icon
		}));
}

function isWithinWindow(tag: HighlightTagSource, now: number): boolean {
	if (tag.startDate && Date.parse(tag.startDate) > now) return false;
	if (tag.endDate && Date.parse(tag.endDate) < now) return false;
	return true;
}
